import React from "react";
import PropTypes from "prop-types";

const colors = [
  "#424874",
  "#50accb",
  "#3cc4ec",
  "#35d687",
  "#d8dbe2",
  "#ffcd3f",
  "#fe703f",
  "#4c53d6"
];

const TaskBreakdown = ({
  tasksCount,
  tasks,
  longestDuration,
  totalDuration
}) => (
  <div className="content-wrapper task-breakdown-container">
    <h1>Task Breakdown</h1>
    {tasksCount > 0 &&
      tasks.map((task, i) => (
        <div key={`${task.totalSeconds}-${i}`} className="task-bar-container">
          <h4>{task[0].task?.description || "N/A"}</h4>
          <div
            className="task-bar"
            style={{
              background: colors[i % colors.length],
              flexBasis: `calc(${
                (task.totalSeconds / longestDuration) * 100
              }% - 150px)`
            }}
          >
            <span className="percentage">
              {((task.totalSeconds / totalDuration) * 100).toFixed(1)}%
            </span>
          </div>
        </div>
      ))}
    {tasksCount === 0 && (
      <div className="no-tasks-container">
        <h4>No Data To Show</h4>
      </div>
    )}
  </div>
);

TaskBreakdown.propTypes = {
  tasks: PropTypes.array,
  tasksCount: PropTypes.number,
  longestDuration: PropTypes.number,
  totalDuration: PropTypes.number
};

TaskBreakdown.defaultProps = {
  tasks: [],
  tasksCount: 0,
  longestDuration: 0,
  totalDuration: 0
};

export default TaskBreakdown;
